<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  .navtop{
    border-bottom:0.01rem solid #eeeeee;
  }
  .main{
    position: relative;
    min-height: 100vh;
    width: 100%;
    background:#fff;
    .footer{
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
  @media (min-width:500px) {
    .main{
    position: relative;
    min-height: 100vh;
    width: 100%;
    background:#fff;
    .footer{
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
    .bhg{
      height: 8.24rem;
    }
  }
  @media (max-width:500px) {
    .main{
    position: relative;
    min-height: 100vh;
    width: 100%;
    background:#fff;
    .footer{
      position: relative;
    }
  }
    .bhg{
      height: 0;
    }
    .footer{
      position: relative;
    }
  }
  .i1{
    position: relative;
    .btmbd{
    position: absolute;
    height: 0.08rem;
    width: 0.4rem;
    left: 50%;
    transform: translateX(-50%);
    bottom: -0.1rem;
    border-radius: 0.2rem;
    background: #2947A9;
  }
  .btmbd1{
    display: none;
  }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue